import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from "@roc/feature-app-core"
import { Paper, Tabs } from '@roc/ui';
import { observer } from "mobx-react"
import { ClosingTodayLoansGrid } from './closingTodayLoansGrid';
import { ClosingNextBusinessDayGrid } from './closingNextBusinessDayGrid';
import { FutureClosingLoansGrid } from './futureClosingLoansGrid';
import { NotClosingLoansGrid } from './notClosingLoansGrid';
import { useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '1600px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}));

export const ClosingAgreedLoansV2 = observer(() => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);

  const TABS = [
    { label: 'Loans Closing Today', },
    { label: 'Loans Closing Tomorrow', },
    { label: 'Future Closing', },
    { label: 'No Closing Date', },
  ];

  const CLOSING_TODAY = 0;
  const CLOSING_NEXT_BUSINESS_DAY = 1;
  const FUTURE_CLOSING = 2;
  const NOT_CLOSING = 3;

  const onTabChange = (e, index) => setSelectedTab(index);

  const renderTabContent = () => {
    switch (selectedTab) {
      case CLOSING_TODAY:
        return <ClosingTodayLoansGrid />;
      case CLOSING_NEXT_BUSINESS_DAY:
        return <ClosingNextBusinessDayGrid />;
      case FUTURE_CLOSING:
        return <FutureClosingLoansGrid />;
      case NOT_CLOSING:
        return <NotClosingLoansGrid />;
    }
  };

  return (
    <Layout containerClass={classes.container}>
      <Tabs
        tabs={TABS}
        selectedTab={selectedTab}
        onTabChange={onTabChange}
      />
      <Paper className={classes.paper}>
        {renderTabContent()}
      </Paper>
    </Layout>
  )
})